import { createFileRoute } from '@tanstack/react-router'
import { AdminGuestRecovery } from '@/components/admin/marketing/AdminGuestRecovery'

export const Route = createFileRoute('/admin/marketing/recovery')({
  component: () => <AdminGuestRecovery />,
})
